<template>
  <div class="Index" style="text-align:center">
    <img v-lazy="'../../static/img/banner2.png'" style="width:100%" alt="">
    <p class="titleClass">3000万卡车司机承载中国76%货运总量</p>
    <img v-lazy="'../../static/img/512.jpg'" style="width:100%" alt="">
    <p class="titleClass">APP已经发布各大应用市场</p>
    <img v-lazy="'../../static/img/26.png'" style="width:100%;margin-left:30px" alt="">
    <div style="display: flex;justify-content: center;">
        <div class="container1">
            <p style="font-size:2.3vw;margin-top:2vw;color:#666">五大盈利模式+五种合作模式</p>
            <p style="font-size:1.3vw;margin-top:0.5vw;color:#666">邀您一起携手共赢</p>
            <div>
                <span style="margin-right:10px">运力合作</span>
                <span style="margin-right:10px">货源合作</span>
                <span style="margin-right:10px">软件合作</span>
                <span style="margin-right:10px">网络货运搭建</span>
                <span>战略合作</span>
            </div>
            <img style="width:96%" v-lazy="'../../static/img/514.jpg'" alt="">
        </div>
    </div>
    <h2 class="h2top" style="margin-top:3vw">REGIONAL AGENT PRIVILEGES</h2>
	<h2 class="h2bottom">区域代理商特权</h2>
	<div class="lineClass" style="width:22vw;margin-left:39%"></div>
	<img style="width:100%" v-lazy="'../../static/img/110.jpg'" alt="">
  <h2 class="h2top" style="margin-top:3vw">EASY TO START BUSINESS</h2>
	<h2 class="h2bottom">创业轻松起步</h2>
	<div class="lineClass" style="width:22vw;margin-left:39%;margin-bottom:0.5vw;"></div>
    <p style="font-size:1.5vw;font-weight: 400;color: #666666;margin-bottom:5vw">全程帮扶：7区32项标准职业化培训</p>
    <img style="width:100%" v-lazy="'../../static/img/745.jpg'" alt="">
    <p style="margin-top:3vw;font-size:1vw;font-weight: 400;color: #484848;">公司拥有中运卡行拥有一支经验丰富、眼光独到，专业创新的软件研发团队，凭借多年的实战经验；</p>
    <p style="margin-top:0.5vw;margin-bottom:3vw;font-size:1vw;font-weight: 400;color: #484848;">一直坚持高标准的服务</p>
    <img style="width:100%" v-lazy="'../../static/img/120.jpg'" alt="">
    <h2 class="h2top" style="margin-top:3vw">THE FIRST TO WITNESS RECRUITMENT</h2>
	<h2 class="h2bottom">网络货运平台2020年首批见证者招募</h2>
	<div class="lineClass" style="width:50vw;margin-left:25%;margin-bottom:0.5vw;"></div>
    <p style="font-size:1.5vw;font-weight: 400;color: #666666;margin-bottom:3vw">招募合伙人 诚邀加盟 共筑伟业</p>
    <From />
  </div>
</template>

<script>
import From from '../components/From.vue'
export default {
  name: 'Index',
  components: {
      From
  },
  mounted () {
     window.scrollTo(0, 0)
  }
}
</script>

<style lang="less" scoped>
.Index{
  margin-top: 66px;
}
.SideCodeBlcok{
  width: 80px;
  height: 220px;
  background:rgba(255, 255, 255, 0.7);
  position: fixed;
  top: 150px;
  right: 10px;
  z-index: 19;
  text-align: center;
}
.SideCodeBlcok img{
  width:60px;
  height: 60px;
  display: block;
  margin:20px 10px 0 10px;
}
.SideCodeBlcok p{
  width: 100%;
  height:20px;
  line-height: 20px;
}
@media (max-width: 640px){
  .SideCodeBlcok{
    display: none;
  }
}
.titleClass {
    font-size: 3vw;
    color: #3699FF;
    margin:2vw 0px;
}
.container1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        margin: 0px 20%;
        div {
            margin: 1vw 2% 3vw 2%;
            display: flex;
            justify-content: space-between;
            span {
                padding: 0.5vw 1vw;
                background-color: #3699FF;
                font-size: 1vw;
                color: white;
            }
        }
        img {
            margin: 0px 2% 0vw 2%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/cooperation.vue